import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import StockoutproducttoproductorderDashboard from '../StockoutproducttoproductorderDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function StockoutproducttoproductorderPage() {
    const dispatch = useDispatch();
    const { stockoutproducttoproductorderList} = useSelector((state)=>state.manufslice)
    useEffect(() => {
        dispatch(openDrawer({'drawerOpen':true}));
    },[]);

    return (
        < StockoutproducttoproductorderDashboard />
    )

}